/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_By_TrackInputs */



/**
* | output |
* | --- |
* | "By Track" |
*
* @param {Segment_By_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_by_track = /** @type {((inputs?: Segment_By_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_By_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Par piste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach Track")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per traccia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("По треку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por pista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラック別")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक के अनुसार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por pista")
	return /** @type {LocalizedString} */ ("By Track")
});